

require("@babel/polyfill");
require('es6-promise').polyfill();
import Vue from 'vue'
import FastClick from 'fastclick'
import router from './router'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'

import store from './store/index.js'
import AV from 'leancloud-storage'
import { User } from './models'
import App from './App'
import filters from './filters'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Search from 'vux/src/components/search/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import CheckIcon from 'vux/src/components/check-icon/index.vue'

import * as Sentry from '@sentry/browser'
import Meta from 'vue-meta'
import InitWechatPlugin from './plugins/initWechat'
import ScrollBottomPlugin from './plugins/scrollBottom'
import VueLazyLoad from 'vue-lazyload'






Vue.use(Meta)
Vue.use(WechatPlugin)
Vue.use(InitWechatPlugin)
Vue.use(ScrollBottomPlugin)
Vue.use(VueLazyLoad)


Vue.use(ConfirmPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.component('popup', Popup)
Vue.component('group', Group)
Vue.component('cell', Cell)
Vue.component('x-textarea', XTextarea)
Vue.component('x-button', XButton)
Vue.component('search', Search)
Vue.component('x-dialog', XDialog)
Vue.component('x-input', XInput)
Vue.component('selector', Selector)
Vue.component('x-address', XAddress)
Vue.component('check-icon', CheckIcon)
Vue.directive('transfer-dom', TransferDom)

AV.init({
appId: "9pq709je4y36ubi10xphdpovula77enqrz27idozgry7x644",
appKey: "364g5iu6q1f3hhwz8wruvmayu3vsap995wh4ws7tszor43np",
serverURLs: 'https://avoscloud.com'
})

AV.setProduction(true)






if (User.current()) {
store.commit('logIn', User.current().toJSON())
User.current().fetch().then(() => {
store.commit('logIn', User.current().toJSON())
})
}

Object.keys(filters).forEach(key => {
Vue.filter(key, filters[key])
})

FastClick.attach(document.body)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
router,
store,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js